var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require('@img/no-data.png')}}),_c('div',{staticClass:"no-data-info"},[_vm._v(_vm._s(_vm.info))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }